import { useMemo, useRef, useState } from "react";
import { Button, Card, message, Modal } from "antd";
import { useRequest } from "ahooks";
import { EditForm } from "../../../components/editForm";
import { Table, DEFAULT_PAGE_DATA } from "../../../components/table";
import { GlobalPayServer } from "../../../server";
import { DEFAULT_QUERY_DATA, generateQueryFormConfig, generateTableColumns } from "./config";
import { Operation } from "./operation";

const server = GlobalPayServer.PayCurrency;

export const PayCurrencyList = () => {
    const operationRef: any = useRef();
    const [loading, setLoading] = useState<boolean>(false);
    const [queryData, setQueryData] = useState<any>({ ...DEFAULT_QUERY_DATA });
    const [tableData, setTableData] = useState<any[]>([]);
    const [pageData, setPageData] = useState<any>({ ...DEFAULT_PAGE_DATA });

    const { run, refresh } = useRequest(server.list, {
        defaultParams: [{ ...pageData }],
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => {
            setTableData([]);
            setPageData({ ...pageData, Total: 0 });
        },
        onSuccess: (res: any) => {
            const { Total, List, Page, PageSize } = res;
            setTableData(List || []);
            setPageData({ Page, PageSize, Total });
        }
    });

    const { run: runDelete, loading: deleteLoading } = useRequest(server.delete, {
        manual: true,
        onSuccess: () => {
            message.success("删除成功");
            refresh();
        },
        onError: (error: any) => {
            message.error("删除失败: " + (error?.message || ""));
        }
    });

    const queryFormConfig = useMemo(() => generateQueryFormConfig(), []);
    const tableColumns = useMemo(() => [
        ...generateTableColumns(),
        {
            title: "操作",
            key: "action",
            fixed: "right",
            width: 150,
            render: (_: any, record: any) => (
                <div style={{ display: "flex", gap: 8 }}>
                    <Button type="link" size="small" onClick={() => operationRef.current?.changeVisible(record, "update")}>编辑</Button>
                    <Button
                        type="link"
                        danger
                        size="small"
                        loading={deleteLoading}
                        onClick={() => {
                            Modal.confirm({
                                title: "确认删除",
                                content: `确定要删除币种"${record.Name}"吗？`,
                                onOk: () => runDelete({ Id: record.Id })
                            });
                        }}
                    >
                        删除
                    </Button>
                </div>
            )
        }
    ], [deleteLoading, runDelete]);

    return (
        <div>
            <Card>
                <div className="flex space-between align-center ">
                    <EditForm
                        componentId="pay-currency-query-form"
                        loading={loading}
                        formAttrsProps={{ layout: "inline" }}
                        formData={queryData}
                        onDataChange={setQueryData}
                        formConfig={queryFormConfig}
                        onQuery={() => run({ ...DEFAULT_PAGE_DATA, ...queryData })}
                        onReset={() => {
                            setQueryData({ ...DEFAULT_QUERY_DATA });
                            run({ ...DEFAULT_QUERY_DATA, ...DEFAULT_PAGE_DATA });
                        }}
                    />
                    <Button type="primary" onClick={() => operationRef.current?.changeVisible({}, "create")}>新增</Button>
                </div>
            </Card>
            <Card className="mt20">
                <Table
                    loading={loading}
                    dataSource={tableData}
                    columns={tableColumns}
                    rowKey="Id"
                    scroll={{ x: "max-content" }}
                    page={pageData}
                    onPageChange={(Page: number, PageSize: number) => {
                        const currentPage = { ...pageData, Page, PageSize };
                        run({ ...currentPage, ...queryData });
                    }}
                />
            </Card>
            <Operation ref={operationRef} onSuccess={refresh} />
        </div>
    );
}
